<template>
  <div>
    <div class="row my-1">
      <router-link class="col-md-1 py-1" to="/adminhome"><< Back</router-link>

      <button
        class="btn btn-success col-md-2 mx-1"
        data-toggle="modal"
        data-target="#createNewUserModal"
      >Create New User</button>

      
      <input type="text" class="col-md-3 form-control" v-on:keyup="filterAnything" v-model='filterText' placeholder="Filter Anything" />
      
    </div>
    <table class="table table-stripe table-hover">
      <thead>
        <tr>
          <th>ID #</th>
          <th>Account</th>
          <th>Is Admin</th>
          <th>
            Ministry Roles Access
            <button class="btn btn-link" v-on:click="toggle">+/-</button>
          </th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="account in accounts" v-show='account.show'>
          <td>{{account.id}}</td>
          <td>{{account.username}}</td>
          <td>
            <span v-if="account.admin">Yes</span>
            <span v-else>No</span>
          </td>
          <td>
            <span v-show="!showAccessDetails">
              <i>Granted {{account.permissions.length}} Role(s)</i>
            </span>
            <ul v-show="showAccessDetails">
              <li v-for="p in account.permissions"><b>{{p.ministryRole.name}}</b> of {{p.ministryRole.department}}</li>
            </ul>
          </td>
          <td>
            <button class="btn btn-primary" v-on:click="goEditAccess(account.id)">Edit Access</button>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Modal -->
    <div
      class="modal fade"
      id="createNewUserModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div
            class="modal-header"
          >Email addressee will receive an email invitation with a link to create an account.</div>
          <div class="modal-body">
            <input
              type="text"
              class="form-control my-2"
              v-model="invitation"
              placeholder="Enter email"
            />
            <!-- <input type="text" class="form-control my-2" placeholder="Email Subject (Optional)">
            <textarea class='form-control my-2' placeholder="Email Content (Optional)"></textarea>-->
          </div>
          <div class="modal-footer">
            <input type="checkbox" v-model="admin" />Grant Admin Rights &nbsp;&nbsp;
            <button
              class="btn btn-success"
              v-on:click="invite"
              :disabled="inviting"
            >
              <span v-show="!inviting">Create & Invite</span>
              <span v-show="inviting">Please wait...</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../commons/http.js";
import auth from "../commons/auth.js";

export default {
  data: function() {
    return {
      showAccessDetails: false,
      accounts: [],
      invitation: "",
      admin: false,
      inviting: false,
      filterText:''
    };
  },
  methods: {
    filterAnything:function(){
      this.accounts.forEach(a => {
        let s = JSON.stringify(a);
        if(s.toLowerCase().includes(this.filterText)){
          a.show = true;
        }else{
          a.show = false;
        }
      });
    },
    toggle: function() {
      this.showAccessDetails = !this.showAccessDetails;
    },
    getAccounts: async function() {
      try {
        let response = await http.get("/account/withpermission");
        this.accounts = response.data;
        this.accounts.forEach(a => {
          a.show = true;
        });
      } catch (err) {
        console.error("/account/withpermission err", err);
      }
    },
    goEditAccess: function(id) {
      this.$router.push("/editmraccess?id=" + id);
    },
    invite: async function() {
      this.inviting = true;
      try {
        await auth.post("/invite", { to: this.invitation });
        alert("Email has been sent");
      } catch (err) {
        console.error("invite email err", err);
        alert("Error sending invitation. Please try again.");
      }

      try {
        await http.post("/account/save", {
          username: this.invitation,
          admin: this.admin
        });
      } catch (err) {
        console.error("create account err", err);
      }
      this.inviting = false;
      this.invitation = "";
    }
  },
  beforeMount: async function() {
    if (!(await http.isLoggedIn(true))) {
      this.$router.push("/adminhome");
    }
    this.getAccounts();
  }
};
</script>

<style>
</style>
